module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-new order-right-summary",
    staticStyle: {
      "text-align": "left"
    }
  }, [(_vm.orderData.warehouse) ? _c('div', {
    staticClass: "ors-time-and-date"
  }, [_c('div', {
    staticClass: "col-auto col-divided"
  }, [_c('strong', [_vm._v("Punkt podjęcia:")]), _vm._v(" "), _c('em', [_vm._v("Agata Meble - " + _vm._s(_vm.orderData.warehouse.City) + "\n            "), _c('br'), _vm._v(_vm._s(_vm.orderData.warehouse.Street) + " " + _vm._s(_vm.orderData.warehouse.StreetNo)), _c('br'), _vm._v("\n                " + _vm._s(_vm.orderData.warehouse.PostalCode) + " " + _vm._s(_vm.orderData.warehouse.City) + "\n            ")])]), _vm._v(" "), (_vm.step > 2) ? _c('div', {
    staticClass: "col-auto col-divided"
  }, [_c('strong', [_vm._v("Adres realizacji:")]), _vm._v(" "), _c('em', [_vm._v(_vm._s(_vm.orderData.address.Street) + " " + _vm._s(_vm.orderData.address.StreetNo)), _c('br'), _vm._v(_vm._s(_vm.orderData.address.PostalCode) + " " + _vm._s(_vm.orderData.address.City))])]) : _vm._e(), _vm._v(" "), (_vm.step > 2 && _vm.orderData.delivery.zoneName) ? _c('div', {
    staticClass: "col-auto col-divided"
  }, [_c('strong', [_vm._v("Strefa transportowa:")]), _c('em', [_vm._v(_vm._s(_vm.orderData.delivery.zoneName))])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderData.delivery.distance),
      expression: "orderData.delivery.distance"
    }],
    staticClass: "col-auto"
  }, [_c('strong', [_vm._v("Dystans:")]), _c('em', [_vm._v(_vm._s(_vm.orderData.delivery.distance) + " km")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-764dceae","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DeliveryPointSection.vue
// module id = 260
// module chunks = 1